import axios from 'axios';

/* let endPointApi = window.location.hostname;
// const localhostEndPoint = 'https://d-serprobots.estaleiro.serpro.gov.br/manager/api';
// const localhostEndPoint = 'https://d-serprobots.estaleiro.serpro.gov.br/gateway-stacks';
const localhostEndPoint = 'https://serprobots.estaleiro.serpro.gov.br/gateway-stacks/';
// const localhostEndPoint = 'https://demo7177110.mockable.io/';

endPointApi = endPointApi !== 'localhost'
  ? `https://${endPointApi}/gateway-stacks/`
  : localhostEndPoint; */

const gatewayEndPoint = axios.create();
export default gatewayEndPoint;
